const colors = {
  // Primary and Accent Colors
  primary: "#5246EE",
  secondary: "#fea735",
  accent: "#4a71ff",
  displayBody: "#455468",
  displayLight: "#d7dee8",
  displayMedium: "#afbaca",
  displayDark: "#8897AE",
  extraGray: "#8797ae",
  gray: "#CED4DA",
  light: "#D7DFE9",
  extraLight: "#e9eff6",
  grayLight: "#f0f3f8",
  neutral: "#B18A00",

  tintInfo: "#3caaf9",
  tintDanger: "#ffa09b",
  tintWarning: "#d8a800",
  tintNeutral: "#c19c60",

  // Text Colors
  header: "#1A1D21",
  subHeader: "#4F5662",
  body: "#3d4a5c",
  bodyText: "#5e718d",
  muted: "#6c757d",

  // Special Cases
  highlight: "#ff574c",
  darkHighlight: "#FF574D",
  lightError: "#ffc5c1",
  error: "#e82215",
  complete: "#1db469",

  success: {
    color: "#11A75C",
    bgColor: "#e4f6ed",
    border: "#1DB46980",
  },
  danger: {
    color: "#FF3838",
    bgColor: "#fff5f4",
    border: "#FFC5C1",
  },
  dark: {
    color: "#5E718D",
    bgColor: "#F0F3F9",
  },
  warning: {
    color: "#D8A800",
    bgColor: "#FFF9DF",
  },
  info: {
    color: "#820BF4",
    bgColor: "#f5ecfe",
  },

  // Theme colors
  theme: {
    primary: "#5246EE",
    primaryRest: "#EDF2FF",
    secondary: "#6C757D",
    indigo: {
      25: "#F4F5FF",
      50: "#DDDFFF",
      100: "#C6CAFF",
      500: "#636DD3",
    },
    error: {
      25: "#FFF5F4",
      50: "#FFDCDA",
      100: "#FFC5C1",
      300: "#FF7A72",
      400: "#FF574D",
      500: "#FF3838",
    },
    cyan: {
      500: "#22BFCE",
    },
    orange: {
      25: "#FFF6ED",
      50: "#FFEBD8",
      400: "#FC8E28",
      500: "#EB7101",
    },
    purple: {
      25: "#F5ECFE",
      50: "#E2C7FC",
      400: "#9631F5",
    },
    sky: {
      50: "#F3FAFF",
      100: "#2497EB",
      500: '#1B4DFF'
    },
    success: {
      25: "#F2FFF9",
      50: "#D7FFEB",
      500: "#11A75C",
    },
    yellow: {
      50: "#FFF2C4",
      200: "#FFE176",
      500: "#FFC700",
      600: "#D8A800",
      700: "#B18A00",
    },
    gray: {
      2: "#050505",
      24: "#3D3D3D",
      30: "#4D4D4D",
      40: "#666666",
      50: "#808080",
      60: "#999999",

      25: "#F4F5F6",
      100: "#C9CDD3",
      400: "#88909F",
      500: "#727C8D",
      600: "#606977",
      700: "#4F5662",
      900: "#1A1D21",
    },
    slate: {
      25: "#F9FAFB",
      100: "#E9EFF6",
      200: "#D7DFE9",
      300: "#AFBACA",
      400: "#8897AE",
      500: "#5E718D",
      600: "#455468",
      800: "#2D3643",
    },
  },
} as const;

export default colors;
